<template>
  <div class="home">

    

  </div>
</template>
<script>
export default {
  data () {
    return {
      test: ''
    }
  },
  mounted() {

   
  },
  methods: {
    

  }
}
</script>
